import { useCallback, useEffect, useState } from "react";
import { applyAnimation, AnimationClass } from "../utils/helpers";
import { usePortableVideoStore } from "@/common/store";
import { useAppStore } from "@/common/store/appStore";

interface IUsePlayerSoundProps {
  ref: React.RefObject<HTMLDivElement | null>;
}

export const usePlayerSound = (props: IUsePlayerSoundProps) => {
  const { ref } = props;
  const gifSound = useAppStore((state) => state.gifSound);
  const [playerSound, setPlayerSound] = useState(gifSound);
  const videoRef = usePortableVideoStore((state) => state.videoRef);
  const toggleGifSound = useAppStore((state) => state.toggleGifSound);

  const toggleSound = useCallback((sound: boolean, persistent: boolean = true, showAnimation: boolean = true) => {
    setPlayerSound(sound);

    if (videoRef.current) {
      videoRef.current.muted = !sound;
    }

    if (showAnimation) {
      applyAnimation({
        ref: ref,
        animationClass: sound ? AnimationClass.SoundOn : AnimationClass.SoundOff
      });
    }

    if (persistent) {
      toggleGifSound(sound);
    }
  }, [ref]);

  useEffect(() => {
    setPlayerSound(gifSound);
  }, [gifSound]);

  return {
    sound: playerSound,
    toggleSound,
  };
};
